import isStringSet from 'utilities/is/isStringSet';
import store from 'utilities/store';
import Keys from 'stateKeys';

export default class VideoRepository {

    storeDeviceId(deviceId) {
        store.set(Keys.UI.Video.SelectedDevice, deviceId);
    }

    getDeviceId() {
        return store.get(Keys.UI.Video.SelectedDevice);
    }

    isMirrored() {
        const flag = store.get(Keys.UI.Video.SelectedDevice);
        return (isStringSet(flag) && Boolean(flag)) || false;
    }

    storeMirrorOption(isMirrored) {
        store.set(Keys.UI.Video.SelectedDevice, String(isMirrored));
    }
}